import React, { useContext } from 'react';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import { useTeamNews } from '../../hooks/news';
import { DataContext } from '../../context/data-context';
import { getProxyUrl } from '../../utils/image';

function SideTeamNews() {
  const { league } = useContext(DataContext);
  const [news, loading, error] = useTeamNews(league);

  if (loading || error) {
    return null;
  }

  return (
    <>
      <p className="heading-h3 mt-2 mb-3 pb-2 px-4">NYHETER FRÅN LAGEN</p>
      {_.uniqBy(news, 'articleUrl')
        ?.slice(0, 4)
        .map((article) => (
            <article className="article-vertical article-vertical--large mb-4">
              <img src={getProxyUrl(article?.image)} alt="" />
              <a href={article?.articleUrl} title={article?.title} className="article-vertical__info">
                <time className="text-small text-color-primary-blue text-uppercase fw-bold mb-1" dateTime={article.dateTime}>
                  {moment(article.dateTime).format('DD MMMM').toUpperCase()}
                </time>
                <h2 className="heading-h5 heading-sm-h5 text-transform-none mb-2">
                  {article?.title}
                </h2>
              </a>
            </article>
        ))}
    </>
  );
}

export default SideTeamNews;
